import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = PropsWithChildren<{
    to: HTMLElement;
}>

export const Portal = ({ to, children }: PortalProps)=> {
    return createPortal(children, to);
}
